import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCplusplusComponent } from './simple-icons-cplusplus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCplusplusComponent ],
    exports:      [ SimpleIconsCplusplusComponent ],
    bootstrap:    []
})
export class SimpleIconsCplusplusModule {}
